'use strict';

var fnTemplate = require('../../components/templates/functions/company-function.tpl');
var template = require('../templates/company-dropdown.tpl');

function render(user, memberships, deps) {
	var _ = deps.underscore;
	var result = '';
	var currentMembership;
	var currentCompany;
	var companies;

	if (user && memberships && memberships.length > 0) {
		currentMembership = _.find(memberships, function(membership) {
			return membership.company.uuid === user.company_id;
		});

		try {
			currentCompany = currentMembership.company.name;
		} catch (e) {
			currentCompany = null;
		}

		companies = memberships.map(function(membership) {
			return {
				label: membership.company.name,
				companyId: membership.company.uuid
			};
		});

		if (currentCompany && companies.length > 1) {
			result = (fnTemplate + _.template(template)({
				userId: user.user_id,
				currentCompany: currentCompany,
				companies: companies
			}));
		}
	}

	return result;
}

module.exports = {
	render: render
};




//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/deprecated/views/company-dropdown.js
// module id = 48
// module chunks = 0